export default __webpack_public_path__ + "static/media/icon_align_small_on.97522b27.svg";